// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const RatingScale: MarkdocTagRegistration = {
  tag: 'rating-scale',
  component: 'RatingScale',
  attributes: {
    rating: {
      type: Number,
    },
    maxRating: {
      type: Number,
      default: 5,
    },
    ratingColor: {
      type: String,
    },
    message: {
      type: String,
      localizable: true,
    },
  },
};
